import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/d'
    },
    {
      path: '/d/:key',
      name: 'MiniCategory',
      component: () => import('@/views/mini_category'),
      meta: {
        title: '商标小项选择工具'
      }
    },
    {
      path: '/unsubscribe/:key',
      name: 'Unsubscribe',
      component: () => import('@/views/unsubscribe'),
      meta: {
        title: '取消订阅'
      }
    },
    {
      path: '/a/:key',
      name: 'Agreement',
      component: () => import('@/views/agreement/index.vue'),
      meta: {
        title: 'Loading...'
      }
    },
    {
      path: '/s/:type/:key',
      name: 'Sign',
      component: () => import('@/views/sign/index.vue'),
      meta: {
        title: '协议签字'
      }
    },
    {
      path: '/404',
      name: 'Error404',
      component: () => import('@/views/error/404'),
      meta: {
        title: '404'
      }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js